import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-lock-closed-icon',
  templateUrl: './lock-closed.svg',
  styleUrls: ['./lock-closed-icon.component.scss'],
})
export class LockClosedIconComponent implements OnInit {
  @Input() strokeColor = 'coral';
  constructor() {
  }

  ngOnInit() {}

}
